import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'containers/misc'
import { Title, Form } from 'components/layout'
import { Button } from 'components/misc'
import { form } from 'helpers/decorators'
import { FormattedMessage, injectIntl } from 'react-intl'
import { TRANSLATION_PROJECTS } from '../../../constants/enums'

@form({
  form: 'upload-translation-result-modal',
  disableHook: true
})
@injectIntl
class UploadTranslationResultModal extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func,
    modalId: PropTypes.string,
    modal: PropTypes.func,
    result: PropTypes.object.isRequired,
    onConfirmed: PropTypes.func.isRequired
  }

  getProjectName = category => {

    if(!category){
      return
    }

    const project = Object.values(TRANSLATION_PROJECTS).find(p => p.id === category)
    return  project ? <FormattedMessage id={project.intlKey} defaultMessage={project.defaultMessage} /> : category
  }
  getFormattedResult = result => {
    if(!result){
      return (<div>Missing result</div>)
    }

    return (
      <div>
        {Object.entries(result).map(([category, languages]) => {
          const successLanguages = []
          const errorMessages = []

          Object.entries(languages).forEach(([lang, { state, message }]) => {
            if (state === "SUCCESS") {
              successLanguages.push(lang)
            } else {
              errorMessages.push(`${lang}: ${message}`)
            }
          })

          return (
            <div key={category} style={{ marginBottom: "1rem", padding: "10px" }}>
              <h3>{this.getProjectName(category)}</h3>
              <p>
                <strong><FormattedMessage id='label.successfully_uploaded_translations' defaultMessage='Successfully uploaded translations: ' /></strong>
                {successLanguages.length > 0 ? successLanguages.join(", ") : "None"}
              </p>
              <p>
                <strong><FormattedMessage id='label.errors_uploaded_translations' defaultMessage='Errors: ' /></strong><br />
                {errorMessages.length > 0 ? errorMessages.join(" | ") : 'There are no errors'}
              </p>
            </div>
          )
        })}
      </div>
    )
  }

  render() {
    const {
      modalId,
      modal,
      onConfirmed,
      result,
      handleSubmit
    } = this.props

    return (
      <Modal id={modalId} modal={modal} customActions>
        <Title h2 intlKey="label.upload_translation_result">
         Upload translation result
        </Title>
        <Form
          className="form"
          onSubmit={handleSubmit(onConfirmed)}
        >
          <div style={{ marginBottom: '15px' }}>
            {this.getFormattedResult(result)}
          </div>

          <div className="row">
            <div className="col-xs-12 text--center">
              <Button
                intlKey="button.dismiss"
                secondary
                type="submit"
                style={{ marginRight: 10 }}
              >
                Dismiss
              </Button>
            </div>
          </div>
        </Form>
      </Modal>
    )
  }
}

export default UploadTranslationResultModal
